import {Checkbox, Fieldset, Space, Text, Tooltip} from "@mantine/core";
import {noop, without} from "lodash";
import {useEffect, useState} from "react";

import classes from "./LayerPanel.module.scss";
import HelpLink from "../HelpLink";

export interface LayerPanelProps {
  layers?: string[];
  onChange?(layers: string[]): void;
}

export default function LayerPanel({
  layers: initialLayers = [],
  onChange = noop,
}: LayerPanelProps) {
  const [layers, setLayers] = useState<string[]>(initialLayers);

  useEffect(() => {
    onChange(layers);
  }, [layers]);

  const handleChange = (event: any, layerName: string): void => {
    const included = layers.includes(layerName);
    if (event.target.checked && !included) {
      // Add to layers set
      setLayers([...layers, layerName]);
    } else if (!event.target.checked && included) {
      // Remove from layers set
      setLayers(without(layers, layerName));
    }
  };

  return (
    <div className={classes.layerPanel}>
      <h2>Map Layers</h2>
      <Fieldset legend="Public lands">
        <Text size="sm">Find free dispersed camping on public land</Text>
        <Space h="lg" />
        <Tooltip withArrow label="Show US National Forest boundaries (green)">
          <Checkbox
            size="md"
            label="National forest land"
            checked={layers.includes("usfs")}
            onChange={event => handleChange(event, "usfs")}
          />
        </Tooltip>
        <Space h="sm" />
        <Tooltip
          withArrow
          label="Show Bureau of Land Management land boundaries (orange)">
          <Checkbox
            size="md"
            label="BLM land"
            checked={layers.includes("blm")}
            onChange={event => handleChange(event, "blm")}
          />
        </Tooltip>
      </Fieldset>
      <Space h="md" />
      <Fieldset legend="Weather">
        <Text size="sm">Find your ideal weather conditions</Text>
        <Space h="lg" />
        <Tooltip withArrow label="Show snow cover (purple is snowiest)">
          <Checkbox
            size="md"
            label="Snow cover"
            checked={layers.includes("snow")}
            onChange={event => handleChange(event, "snow")}
          />
        </Tooltip>
        <Space h="sm" />
        <Tooltip withArrow label="Show flash flood risk (red is is worst)">
          <Checkbox
            size="md"
            label={
              <div>
                Flash flood <HelpLink slug="flash-flood-risk" title="risk" />
              </div>
            }
            checked={layers.includes("fflood")}
            onChange={event => handleChange(event, "fflood")}
          />
        </Tooltip>
      </Fieldset>
    </div>
  );
}
